module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "controls"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.run
    }
  }, [_vm._v(_vm._s(_vm.$t('run')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.clear
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t('reset')))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isPreviousButton
    },
    on: {
      "click": _vm.previous
    }
  }, [_vm._v(_vm._s(_vm.$t('previous')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isNextButton
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v(_vm._s(_vm.$t('next')))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.selectFinder
    },
    model: {
      value: (_vm.finder),
      callback: function($$v) {
        _vm.finder = $$v
      },
      expression: "finder"
    }
  }, _vm._l((_vm.finders), function(f) {
    return _c('el-option', {
      key: f.value,
      attrs: {
        "label": f.label,
        "value": f.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-row', [_c('el-radio-group', {
    on: {
      "change": _vm.selectCornerWalk
    },
    model: {
      value: (_vm.cornerWalk),
      callback: function($$v) {
        _vm.cornerWalk = $$v
      },
      expression: "cornerWalk"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Orthogonal"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Diagonal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-radio-group', {
    on: {
      "change": _vm.selectHeuristic
    },
    model: {
      value: (_vm.heuristic),
      callback: function($$v) {
        _vm.heuristic = $$v
      },
      expression: "heuristic"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Manhattan"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Euclidean"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Octile"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Chebyshev"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2980d96e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls.vue
// module id = 157
// module chunks = 1